import {
  Box,
  Button,
  FormLabel,
  HStack,
  IconButton,
  Input,
  VStack,
} from "@chakra-ui/react"
import { FiPlus, FiTrash2 } from "react-icons/fi"

export type ExtraDataItem = {
  key: string
  value: string
}

type Props = {
  items: ExtraDataItem[]
  onChange: (items: ExtraDataItem[]) => void
}

export default function ExtraDataFields({ items, onChange }: Props) {
  const handleAddItem = () => {
    onChange([...items, { key: "", value: "" }])
  }

  const handleRemoveItem = (index: number) => {
    const newItems = items.filter((_, i) => i !== index)
    onChange(newItems)
  }

  const handleChange = (
    index: number,
    field: keyof ExtraDataItem,
    value: string,
  ) => {
    const newItems = [...items]
    newItems[index][field] = value
    onChange(newItems)
  }

  return (
    <Box>
      <FormLabel>Dodatkowe dane</FormLabel>
      <VStack align="stretch" spacing={2}>
        {items.map((item, index) => (
          <HStack key={index} spacing={2}>
            <Input
              placeholder="Klucz"
              value={item.key}
              onChange={(e) => handleChange(index, "key", e.target.value)}
            />
            <Input
              placeholder="Wartość"
              value={item.value}
              onChange={(e) => handleChange(index, "value", e.target.value)}
            />
            <IconButton
              aria-label="Usuń pole"
              icon={<FiTrash2 />}
              colorScheme="red"
              variant="ghost"
              onClick={() => handleRemoveItem(index)}
            />
          </HStack>
        ))}
        <Button
          leftIcon={<FiPlus />}
          size="sm"
          variant="outline"
          onClick={handleAddItem}
          alignSelf="flex-start"
        >
          Dodaj pole
        </Button>
      </VStack>
    </Box>
  )
}

export function jsonToExtraData(json: any): ExtraDataItem[] {
  if (!json || typeof json !== "object" || Array.isArray(json)) {
    return []
  }
  return Object.entries(json).map(([key, value]) => ({
    key,
    value: String(value),
  }))
}

export function extraDataToJson(items: ExtraDataItem[]): any {
  const validItems = items.filter((item) => item.key.trim() !== "")
  if (validItems.length === 0) return null

  const obj: Record<string, any> = {}
  validItems.forEach((item) => {
    obj[item.key.trim()] = item.value
  })
  return obj
}
